module.exports = __webpack_public_path__ + "static/media/SerieAG.dc4719ea.jpg";